// extracted by mini-css-extract-plugin
module.exports = {"row":"Birha","col":"Xro2s"};